// Safari throws SecurityError ("The operation is insecure.") on any touch of
// window.localStorage / sessionStorage when site storage is blocked — "Block
// All Cookies", some in-app browsers. AuthContext reads the token in its
// first render, so the whole app fell to the root ErrorBoundary instead of
// showing a public camp page (Sentry PROZPECTS-PROD-4N, 2026-10-21). Rather
// than guard ~85 call sites, swap in an in-memory store: the visitor just
// isn't remembered between page loads.
//
// index.js imports this FIRST, so it runs before any module that reads
// storage at import time.

export function memoryStorage() {
  let items = new Map();
  return {
    get length() { return items.size; },
    key: (i) => Array.from(items.keys())[i] ?? null,
    getItem: (k) => (items.has(String(k)) ? items.get(String(k)) : null),
    setItem: (k, v) => { items.set(String(k), String(v)); },
    removeItem: (k) => { items.delete(String(k)); },
    clear: () => { items = new Map(); },
  };
}

function usable(win, name) {
  try {
    const s = win[name];
    const probe = '__pz_storage_probe__';
    s.setItem(probe, probe);
    s.removeItem(probe);
    return true;
  } catch (e) {
    return false;
  }
}

// Returns the names it replaced, for the test.
export function installStorageFallback(win) {
  const replaced = [];
  ['localStorage', 'sessionStorage'].forEach((name) => {
    if (usable(win, name)) return;
    try {
      Object.defineProperty(win, name, {
        value: memoryStorage(),
        configurable: true,
        writable: true,
      });
      replaced.push(name);
    } catch (e) {
      // Not replaceable here; the old behaviour stands.
    }
  });
  return replaced;
}

if (typeof window !== 'undefined') installStorageFallback(window);
